import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SituationSelect from './components/SituationSelect'
import SignatoriesModule from './components/SignatoriesModule'

import { Button } from 'hosman-material';
import { D_CircleExclamation } from 'hosman-material';

import { updateCurrentStep } from '../../../../../../../reducers/SellerApp/mandatesSlice';
import { scrollToSection } from '../../../../../../../../shared/utils/uiEffects/scrollTo';

const Situation = () => {
  const { currentStep, mandate: { sign_person } } = useSelector((state) => state.sellerMandates);
  const { signatories } = useSelector((state) => state.sellerSalesUsers);
  const [error, setError] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    if (sign_person !== 'n_owners_n_signers') return;

    setTimeout(() => {
      scrollToSection(document.getElementById('SignatoriesModule'));
    }, 500);
  }, [sign_person]);

  const handleNext = () => {
    if (signatories.length > 1 || sign_person !== 'n_owners_n_signers') {
      dispatch(updateCurrentStep(currentStep.number + 1));
    } else {
      setError("Il n'y a qu'un seul signataire enregistré")
    }
  }

  return (
    <div className='flex flex-col gap-8 text-ih-indigo' data-testid='Situation'>
      <p className='h2'>Quelle est votre situation ?</p>

      <SituationSelect setError={setError} />

      {sign_person === 'n_owners_n_signers' && <SignatoriesModule />}

      {error &&
        <div className='flex justify-start items-center gap-2' data-testid='Error'>
          <FontAwesomeIcon icon={D_CircleExclamation} size='lg' className='text-ih-red' />

          <p className='text-ih-red-60'>{error}</p>
        </div>
      }
      
      <div className='flex flex-col md:flex-row justify-between gap-3'>
        <Button label='Retour' type='tertiary' onClick={() => dispatch(updateCurrentStep(currentStep.number - 1))} />
        <Button label='Étape suivante' onClick={handleNext} disabled={sign_person === null} />
      </div> 
    </div>
  );
}

export default Situation;
